import { createRoute } from "@tanstack/react-router";
import { ConsultantSummaryPage } from "@/components/consultants/consultant-summary-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/consultants/summary",
  component: ConsultantSummaryPage,
});
